import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestLogIn(email, password, remember) {
    return axios.request({
        method: "post",
        data: { email, password, remember },
        url: getApiUrl() + "/auth/login",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestLoggedInStatus() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/auth/isLogged",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestLogOut() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/auth/logout",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestForgotPassword(email, otp) {
    if (!email) {
        throw new Error('Please enter your email address.');
    }
    const query = otp ? "/auth/passwordless-login" : "/auth/forgot-password";
    return axios.request({
        method: "post",
        data: { email, oneTimeCode: otp },
        url: getApiUrl() + query,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestNewRegistration(client, user, account) {
    return axios.request({
        method: "post",
        data: { client, user, account },
        url: getApiUrl() + "/auth/register",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestSetup2FA() {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/auth/2fa/setup",
        withCredentials: true,
    });
}

export function requestEnable2FA(password, code) {
    return axios.request({
        method: "post",
        data: { password, code },
        url: getApiUrl() + "/auth/2fa/enable",
        withCredentials: true,
    });
}

export function requestDisable2FA(password, code) {
    return axios.request({
        method: "post",
        data: { password, code },
        url: getApiUrl() + "/auth/2fa/disable",
        withCredentials: true,
    });
}

export function requestRegenerateBackupCodes(password, code) {
    return axios.request({
        method: "post",
        data: { password, code },
        url: getApiUrl() + "/auth/2fa/backup-codes/regenerate",
        withCredentials: true,
    });
}

export function requestVerify2FA(mfaToken, code, rememberDevice) {
    return axios.request({
        method: "post",
        data: { mfaToken, code, rememberDevice },
        url: getApiUrl() + "/auth/2fa/verify",
        withCredentials: true,
    });
}

export function requestGetTrustedDevices() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/auth/2fa/trusted-devices",
        withCredentials: true,
    });
}

export function requestRevokeTrustedDevice(id) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/auth/2fa/trusted-devices/" + encodeURIComponent(id),
        withCredentials: true,
    });
}

export function requestRevokeAllTrustedDevices() {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/auth/2fa/trusted-devices",
        withCredentials: true,
    });
}